import { useIntl } from '@capsicum/common';
import { BinanceIcon, ChilizXIcon, MetamaskIcon, ParibuIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

export const WithdrawCHZSupportedWalletsTable = () => {
	const { $t } = useIntl();

	return (
		<S.TableContainer>
			<S.MainContainer>
				<S.Title>{$t('wallet.withdraw.warningCHZWithdrawDrawer.tableTitle')}</S.Title>
				<S.TopTableContainer>
					<S.TopTitleContainer>
						<span>{$t('wallet.withdraw.warningCHZWithdrawDrawer.chilizX')}</span>
						<ChilizXIcon />
					</S.TopTitleContainer>
					<S.TopTitleContainer>
						<span>{$t('wallet.withdraw.warningCHZWithdrawDrawer.binance')}</span>
						<BinanceIcon />
					</S.TopTitleContainer>
					<S.TopTitleContainer>
						<span>{$t('wallet.withdraw.warningCHZWithdrawDrawer.paribu')}</span>
						<ParibuIcon />
					</S.TopTitleContainer>
					<S.TopTitleContainer>
						<span>{$t('wallet.withdraw.warningCHZWithdrawDrawer.metaMask')}</span>
						<MetamaskIcon />
					</S.TopTitleContainer>
				</S.TopTableContainer>
				<a
					href="https://docs.chiliz.com/chiliz-chain-ecosystem#exchanges"
					rel="noopener noreferrer"
					target="_blank"
				>
					{$t('wallet.withdraw.warningCHZWithdrawDrawer.text3')}
				</a>
			</S.MainContainer>
		</S.TableContainer>
	);
};

namespace S {
	export const TableContainer = styled.div`
		width: 100%;
		max-width: 700px;
		margin: ${({ theme }) => theme.spacings.xxsmall} 0;
	`;
	export const MainContainer = styled.fieldset`
		padding: ${({ theme }) => theme.spacings.small};
		border-radius: ${({ theme }) => theme.sizing.xsmall};
		border: ${({ theme }) => theme.border.width.small} solid ${({ theme }) => theme.colors.borders.main.subtle};
	`;
	export const Title = styled.legend`
		${({ theme }) => theme.fonts.text.text1};
		text-align: center;
	`;
	export const TopTableContainer = styled.div`
		display: flex;
		justify-content: space-around;
		margin-bottom: ${({ theme }) => theme.spacings.small};
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
	export const TopTitleContainer = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		${({ theme }) => theme.fonts.text.text3};
	`;
}
